module.exports = __webpack_public_path__ + "static/media/eminence-ikebukuro-1.5d5fcfbb.jpg";